import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'

// import other components within the same project here

import Localization from "../Localization.jsx"
import ProfileDialog from "../views/ProfileDialog.jsx"
import ChangePasswordDialog from "../views/ChangePasswordDialog.jsx"
import ReportBugDialog from "../views/ReportBugDialog.jsx"
import AdminTaskDialog from "../views/admin/AdminTaskDialog.jsx"
import StorageViewerDialog from "../views/storage/StorageViewerDialog.jsx"
import DeploymentViewerDialog from "../views/deployment/DeploymentViewerDialog.jsx"

import { Icon, Button, Box, IconButton, Tooltip, Menu, MenuItem, Switch, AppBar, Toolbar, Typography, TextField } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';

const styles = {
  grow: {
    flexGrow: 1
  },
}

class TopBar extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      anchorEl: null,
      isLanguageMenuOpen: false,
      isAccountMenuOpen: false,
      isAdminMenuOpen: false,
      isSettingMenuOpen: false,
      isDarkModeEnabled: false,
    };
    autoBind(this);
  }

  handleMenuClose = () => {
    this.setState({
      anchorEl: null,
      isLanguageMenuOpen: false,
      isAccountMenuOpen: false,
      isAdminMenuOpen: false,
      isSettingMenuOpen: false,
    });

    this.state.isLanguageMenuOpen = false;
    this.state.isAccountMenuOpen = false;
    this.state.isAdminMenuOpen = false;
    this.state.isSettingMenuOpen = false;
  };

  handleLanguageMenuOpen = event => {
    this.setState({ isLanguageMenuOpen: true });
    this.state.isLanguageMenuOpen = true;

    this.setState({ anchorEl: event.currentTarget });
    this.state.anchorEl = event.currentTarget;
  }

  handleAccountMenuOpen = event => {
    this.setState({ isAccountMenuOpen: true });
    this.state.isAccountMenuOpen = true;

    this.setState({ anchorEl: event.currentTarget });
    this.state.anchorEl = event.currentTarget;
  }

  adminTaskClicked() {
    this.refs.adminTaskDialog.setState({ open: true });
    this.refs.adminTaskDialog.state.open = true;
  }

  handleSettingMenuOpen = event => {
    this.setState({ isSettingMenuOpen: true });
    this.state.isSettingMenuOpen = true;

    this.setState({ anchorEl: event.currentTarget });
    this.state.anchorEl = event.currentTarget;
  }

  languageClicked(language) {
    Localization.strings.setLanguage(language);
    this.handleMenuClose();
    this.props.root.languageChanged();
  }

  profileClicked() {
    this.refs.profileDialog.setState({open: true});
    this.handleMenuClose();
  }

  changePasswordClicked() {
    this.refs.changePasswordDialog.setState({open: true});
    this.handleMenuClose();
  }

  logoutClicked() {
    this.props.root.refs.API.request("user_logout", {}, this.logoutOK, this.logoutFailed);
  }

  logoutOK(res) {
    this.props.root.logout();
  }

  logoutFailed(err) {
    console.log("logout failed " + err);
  }

  handleDarkModeChanged(event) {
    this.setState({ isDarkModeEnabled: event.target.checked });
    this.state.isDarkModeEnabled = event.target.checked;
  }

  switchBackToClassicCLicked() {
    window.open("//vrhost.ev-cuhk.net/~evvr/client_v1/", "_self");
  }

  reportBugClicked() {
    this.refs.reportBugDialog.setState({open: true});
    this.handleMenuClose();
  }

  storageViewerClicked() {
    this.refs.storageViewerDialog.setState({ open: true });
    this.refs.storageViewerDialog.state.open = true;
  }

  deploymentViewerClicked() {
    this.refs.deploymentViewerDialog.setState({ open: true });
    this.refs.deploymentViewerDialog.state.open = true;
  }

  render() {
      return (
        <div>
          <AppBar
            position="static"
            style={{ backgroundColor: this.props.theme.palette.primary.main, boxShadow: 'none'}}
          >
            <Toolbar>
              <Typography variant="h5" style={{color:'White'}}>
                EduVenture VR Composer
              </Typography>
              <div style={styles.grow} />
              
              <If condition={this.props.root.getAccountSubscriptionDaysLeft() != ""}>
                <Then>
                  <Tooltip 
                    title={
                      <div style={{ padding: '6px 4px', fontSize: '13px', lineHeight: '1.4' }}>
                        <strong>Subscription Period:</strong><br/>
                        {this.props.root.getAccountStartDate()} - {this.props.root.getAccountExpiryDate()}
                      </div>
                    } 
                    placement="bottom-end"
                    arrow
                  >
                    <div style={{ marginLeft: 16 }}>
                      <Button
                        disabled
                        style={{
                          background: this.props.theme.palette.primary.dark,
                          borderRadius: 6,
                          border: 0,
                          color: 'rgba(255, 255, 255, 0.9)',
                          height: 32,
                          padding: '0 12px',
                          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '12px',
                          textTransform: 'none',
                          opacity: 0.85,
                          transition: 'all 0.3s ease',
                          fontSize: '13px',
                          '&:hover': {
                            opacity: 1,
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.23)',
                          }
                        }}
                        id='expiry_btn'
                      >
                        <Icon style={{ fontSize: 16, opacity: 0.9 }}>timer</Icon>
                        <span style={{ fontWeight: 400 }}>
                          {Localization.strings.ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_BAR + this.props.root.getAccountSubscriptionDaysLeft()}
                        </span>
                      </Button>
                    </div>
                  </Tooltip>
                </Then>
              </If>
                
                <Tooltip title={Localization.strings.LANGUAGE} placement="bottom-end">
                  <IconButton
                    style={{color:'White'}}
                    variant="fab"
                    aria-haspopup="true"
                    onClick={this.handleLanguageMenuOpen}
                  >
                    <Icon>language</Icon>
                  </IconButton>
                </Tooltip>
                <Menu
                  disableAutoFocusItem={true}
                  anchorEl={this.state.anchorEl}
                  transformOrigin={{ vertical: "top", horizontal: "center" }}
                  open={this.state.isLanguageMenuOpen}
                  onClose={this.handleMenuClose}
                >
                  <MenuItem onClick={() => this.languageClicked("en")}>English</MenuItem>
                  <MenuItem onClick={() => this.languageClicked("tc")}>繁體中文</MenuItem>
                  <MenuItem onClick={() => this.languageClicked("sc")}>简体中文</MenuItem>
                </Menu>
                <Tooltip title={Localization.strings.DEPLOYMENT} placement="bottom-end">
                  <IconButton
                    style={{color:'White'}}
                    variant="fab"
                    aria-haspopup="true"
                    onClick={this.deploymentViewerClicked}
                  >
                    <Icon>date_range</Icon>
                  </IconButton>
                </Tooltip>
                <If condition={this.props.root.getOriginalUserRole() >= 1}>
                  <Then>
                    <Tooltip title={Localization.strings.STORAGE} placement="bottom-end">
                      <IconButton
                        style={{color:'White'}}
                        variant="fab"
                        aria-haspopup="true"
                        onClick={this.storageViewerClicked}
                      >
                        <Icon>storage</Icon>
                      </IconButton>
                    </Tooltip>
                  </Then>
                </If>
              <Tooltip title={Localization.strings.ACCOUNT_SETTINGS} placement="bottom-end">
                <IconButton
                  style={{color:'White'}}
                  variant="fab"
                  aria-haspopup="true"
                  onClick={this.handleAccountMenuOpen}
                >
                  <Icon>account_circle</Icon>
                </IconButton>
              </Tooltip>
              <Menu
                disableAutoFocusItem={true}
                anchorEl={this.state.anchorEl}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                open={this.state.isAccountMenuOpen}
                onClose={this.handleMenuClose}
              >
                <MenuItem onClick={this.profileClicked}>{Localization.strings.PROFILE}</MenuItem>
                <MenuItem onClick={this.changePasswordClicked}>{Localization.strings.CHANGE_PASSWORD}</MenuItem>
                <MenuItem onClick={this.logoutClicked}>{Localization.strings.LOGOUT}</MenuItem>
              </Menu>
              <If condition={this.props.root.getOriginalUserRole() >= 3}>
                <Then>
                  <Tooltip title={Localization.strings.ADMIN_TASK} placement="bottom-end">
                    <IconButton
                      style={{color:'White'}}
                      variant="fab"
                      aria-haspopup="true"
                      onClick={this.adminTaskClicked}
                    >
                      <Icon>lock_outline</Icon>
                    </IconButton>
                  </Tooltip>
                </Then>
              </If>
              <Tooltip title={Localization.strings.SETTINGS} placement="bottom-end">
                <IconButton
                  style={{color:'White'}}
                  variant="fab"
                  aria-haspopup="true"
                  onClick={this.handleSettingMenuOpen}
                >
                  <Icon>settings</Icon>
                </IconButton>
              </Tooltip>
              <Menu
                disableAutoFocusItem={true}
                anchorEl={this.state.anchorEl}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                open={this.state.isSettingMenuOpen}
                onClose={this.handleMenuClose}
              >
                <MenuItem disabled={true}>
                  {Localization.strings.DARK_MODE}
                  <Switch
                    checked={this.state.isDarkModeEnabled}
                    color="primary"
                    onChange={this.handleDarkModeChanged}
                  />
                </MenuItem>
                {/* <MenuItem onClick={this.switchBackToClassicCLicked}>{Localization.strings.SWITCH_BACK_TO_CLASSIC_UI}</MenuItem> */}
                <MenuItem onClick={this.reportBugClicked}>{Localization.strings.REPORT_BUG}</MenuItem>
              </Menu>
              <Tooltip title={Localization.strings.LOGOUT} placement="bottom-end">
                <IconButton
                  style={{color:'White'}}
                  variant="fab"
                  onClick={this.logoutClicked}
                >
                  <Icon>exit_to_app</Icon>
                </IconButton>
              </Tooltip>
            </Toolbar>
          </AppBar>

          <ProfileDialog parent={this} root={this.props.root} ref="profileDialog"/>
          <ChangePasswordDialog parent={this} root={this.props.root} ref="changePasswordDialog"/>
          <ReportBugDialog parent={this} root={this.props.root} ref="reportBugDialog"/>
          <AdminTaskDialog parent={this} root={this.props.root} ref="adminTaskDialog"/>
          <StorageViewerDialog parent={this} root={this.props.root} ref="storageViewerDialog" />
          <DeploymentViewerDialog parent={this} root={this.props.root} ref="deploymentViewerDialog" />

        </div>
      )
  }
}

export default withTheme(TopBar);
